import Header from './components/Header';
import Main from './components/Main';
import { motion, useScroll } from "framer-motion";
function App() {

  const { scrollYProgress } = useScroll();
  return (
    <div className="App">
      <Header/>
      <motion.div
        className="progress-bar"
        style={{ scaleX: scrollYProgress }}
      />

      <Main/>
    </div>
  );
}

export default App;
